import { Component, OnInit, TemplateRef, ViewChild, AfterViewInit } from '@angular/core';
import { MonitorService } from '../../../../common/services/Monitor.service';
import { GroupService } from '../../../../common/services/Group.service';
import { ChatService } from '../../../../common/services/Chat.service';
import { SocketService } from '../../../../common/services/Socket.service';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../../../common/services/User.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
declare var $: any;
declare var Chartist: any;
declare const Timer: any;

@Component({
    templateUrl: "monitor.template.html",
    styleUrls: ['monitor.css'],
    providers: [MonitorService, GroupService, UserService]
})



export class MonitorComponent implements OnInit {
    public tab: any = 'call';
    public no_image: any = 'assets/images/contact.png';
    public data_agent_dashboard: any = {};
    public data_call_dashboard: any = {};
    public data_call: any = {};
    // lay call daily tu omap
    public calldaily: any = {};
    public data_agent: any = [];
    public callList: any = [];
    public timerList: any = [];
    public all_group: any = {};
    public ioConnection: any;
    public agentId: any;
    public statusTypes = [
        { id: 'AVAILABLE', text: 'Sẵn sàng làm việc' },
        { id: 'NOT AVAILABLE', text: 'Chưa sẵn sàng làm việc' },
        { id: 'NOACD', text: 'Không nhận cuộc gọi' },
        { id: 'ONCAMPAIGN', text: 'Thực hiện chiến dịch' },
        { id: 'TYPING', text: 'Typing' },
        { id: 'ATLUNCH', text: 'Ăn trưa' },
        { id: 'MEETING', text: 'Đi họp' },
        { id: 'TRAINING', text: 'Đào tạo' },
        { id: 'GOOUT', text: 'Đi ra ngoài' },
    ];

    public statusChangeTypes = [
        { id: 'AVAILABLE', text: 'Sẵn sàng làm việc' },
        { id: 'NOT AVAILABLE', text: 'Chưa sẵn sàng làm việc' },
    ];
    // dialog
    public list: any = [];
    public totalItem: any = 0;
    public totalPage: any = 0;
    public page_size: number = 5;
    public currentPage: number = 1;
    public modelFilter: any = {};
    public is_load_data: boolean = false;
    public modelPhoneOut: any = {};
    public allFillterGroup: any = [{ id: '', text: '' }];
    public user: any;
    public currentCall: any;

    @ViewChild('lgModalOutPhone') lgModalOutPhone: BsModalRef;

    constructor(
        private monitorService: MonitorService,
        private groupService: GroupService,
        private chatService: ChatService,
        private socketService: SocketService,
        private toastr: ToastrService,
        private userService: UserService,
        private modalService: BsModalService

    ) {
        this.user = JSON.parse(localStorage.getItem('User'));
        this.agentId = localStorage.getItem('agentId');
        this.initIoConnection();
        this.socketService.missionAnnounced$.subscribe(
            mission => {
                console.log('mission', JSON.stringify(mission));
                if (mission.action == 'update-monitor' && this.tab == 'call') {
                    this.loadCall();
                } else if (mission.action == 'update-monitor-all-agent') {
                    this.data_agent = mission.data.agents;
                } else if (mission.action == 'update-monitor-agent') {
                    if (this.data_agent) {
                        this.data_agent.forEach(agent => {
                            if (agent.username == mission.data.username) {
                                agent.status = mission.data.status;
                                agent.facebookStatus = mission.data.facebookStatus;
                                agent.chatStatus = mission.data.chatStatus;
                                agent.emailStatus = mission.data.emailStatus;
                                agent.zaloStatus = mission.data.zaloStatus;
                                return;
                            }
                        })
                    }
                } else if (mission.action == 'update-monitor-call') {
                    this.data_call_dashboard = mission.data;
                } else if (mission.action == 'update-monitor-agent-dashboard') {
                    this.data_agent_dashboard = mission.data;
                } else if (mission.action == 'update-monitor-calllist') {
                    this.callList = mission.data;
                    let callList = [];
                    this.callList.forEach(call => {
                        if (call && call.status != 'END_CALL') {
                            callList.push(call);
                        }
                    });
                    this.callList = callList;
                    this.createAllTimers();
                } else if (mission.action == 'update-monitor-calldetail') {
                    let agentCalls = mission.data;
                    let existed = false;
                    if (agentCalls && agentCalls.length > 0) {
                        let callinfo = agentCalls[0];
                        for (let i = 0; i < this.callList.length; i++) {
                            if (this.callList[i].callId == callinfo.callId) {
                                this.callList[i] = callinfo;
                                existed = true;
                            }
                        }
                        if (!existed) {
                            this.callList.push(callinfo);
                        }
                        let callList = [];
                        this.callList.forEach(call => {
                            if (call && call.status != 'END_CALL') {
                                callList.push(call);
                            }
                        });
                        this.callList = callList;
                        this.createTimerById(callinfo.callId, callinfo.duration);
                    }

                } else if (mission.action == 'update-monitor-calldetail-end') {
                    let callId = mission.data;
                    let callList = [];
                    this.callList.forEach(call => {
                        if (call && call.callId != callId && call.status != 'END_CALL') {
                            callList.push(call);
                        }
                    });
                    this.callList = callList;
                    this.destroyTimerById(callId);
                }
            }
        )
    }

    ngOnInit() {
        // this.groupService.allGroup().subscribe(res => {
        //     if (res.status == 200 && res.error == false) {
        //         res.data.forEach(e => {
        //             this.all_group[e.id] = e.name;
        //         });
        //     }
        // })
        this.loadCall();
        this.socketService.loadCallMonitor();
        this.socketService.loadCallList();
        this.getGroup();
    }

    changeAgentStatus($event, agent) {
        let data = {
            status: $event.value,
            agentId: agent.agentId,
            superAgentId: this.agentId
        }
        this.socketService.changeAgentStatusSupervisor(data);
    }

    changeChannelStatus($event, agent, channel) {
        let data = {
            agentId: agent.agentId,
            superAgentId: this.agentId
        }
        data[channel] = $event.value
        this.socketService.changeAgentStatusSupervisor(data);
    }

    changeTab(tab) {
        this.tab = tab;
        if (tab == 'call') {
            this.loadCall();
            this.socketService.loadCallMonitor();
        }
        else if (tab == 'agent') {
            this.socketService.loadAgentMonitor();
            // this.loadAgent();
            this.loadGroup();
        }
    }
    loadGroup() {
        this.groupService.allGroup().subscribe(res => {
            if (res.status == 200 && res.error == false) {
                res.data.forEach(e => {
                    this.all_group[e.id] = e.name;
                });
            }
        });
    }
    loadCall() {
        let user = JSON.parse(localStorage.getItem('User'));
        let tenantId = user.tenant_id;
        this.monitorService.getCallDaily(tenantId).subscribe(res => {
            if (res.status == 200) {
                this.calldaily = res.data;
            }
        })
        this.monitorService.call().subscribe(res => {
            if (res.status == 200 && res.error == false) {
                this.data_call = res.data;
                // lay email cho tu emailgateway
                this.monitorService.getInqueueEmails(tenantId).subscribe(res => {
                    if (res.status == 200) {
                        this.data_call.analytic.totalEmailWaiting = res.data;
                    }
                });
            }
        })
    }

    loadAgent() {
        this.monitorService.agent().subscribe(res => {
            if (res.status == 200 && res.error == false) {
                this.data_agent = res.data;
            }
        })
    }

    private initIoConnection(): void {

        this.ioConnection = this.chatService.onUpdateMonitor()
            .subscribe((message: any) => {
                if (this.tab == 'call') {
                    console.log('monitor', message)
                    this.loadCall();
                }
            });

        this.chatService.onEvent("connect")
            .subscribe(() => {
                console.log('connected');
            });

        this.chatService.onEvent("disconnect")
            .subscribe(() => {
                console.log('disconnected');
            });
    }
    createTimerById(id: any, duration: any) {
        // destroy timer
        this.destroyTimerById(id);
        let timer = new Timer();
        //timer.reset();
        timer.start({ precision: 'seconds', startValues: { seconds: duration } });
        timer.addEventListener('secondsUpdated', function (e) {
            $('#' + id).html(timer.getTimeValues().toString());
        });
        this.timerList.push({ id: id, timer: timer });
    }
    destroyTimerById(id: any) {
        let index = -1;
        for (let i = 0; i < this.timerList.length; i++) {
            if (this.timerList[i] && this.timerList[i].id == id) {
                index = i;
                this.destroyTimer(this.timerList[i].timer);
                break;
            }
        }
        if (index != -1) {
            this.timerList.splice(index, 1);
        }

    }
    destroyAllTimers() {
        for (let i = 0; i < this.timerList.length; i++) {
            this.destroyTimer(this.timerList[i].timer);
        }
        this.timerList = [];
    }
    createAllTimers() {
        // xoa tat ca timer dang ton tai neu co
        this.destroyAllTimers();
        for (let i = 0; i < this.callList.length; i++) {
            this.createTimerById(this.callList[i].callId, this.callList[i].duration);
        }
    }
    destroyTimer(timer: any) {
        timer.stop();
    }
    listen(call: any) {
        if (!call.answered) {
            this.toastr.success('Cuộc gọi chưa trả lời', '', {
                timeOut: 3000,
                positionClass: 'toast-bottom-right'
            });
            return;
        }
        let data = { action: 'listen', callId: call.callId };
        this.socketService.interact(data);
    }
    join(call: any) {
        if (!call.answered) {
            this.toastr.success('Cuộc gọi chưa trả lời', '', {
                timeOut: 3000,
                positionClass: 'toast-bottom-right'
            });
            return;
        }
        let data = { action: 'join', callId: call.callId };
        this.socketService.interact(data);
    }
    transfer(call: any) {
        if (!call.answered) {
            this.toastr.success('Cuộc gọi chưa trả lời', '', {
                timeOut: 3000,
                positionClass: 'toast-bottom-right'
            });
            return;
        }
        let data = { action: 'transfer', callId: call.callId };
        this.socketService.interact(data);
    }
    invite(call: any) {
        if (!call.answered) {
            this.toastr.success('Cuộc gọi chưa trả lời', '', {
                timeOut: 3000,
                positionClass: 'toast-bottom-right'
            });
            return;
        }
        // let data = {action:'invite', callId:call.callId};
        // this.socketService.interact(data);
    }
    disconnect(call: any) {
        let data = { action: 'disconnect', callId: call.callId };
        this.socketService.interact(data);
    }
    selectCall(call: any) {
        this.currentCall = call;
    }
    transferToAgent(agentId: any) {
        if (!this.currentCall.answered) {
            this.toastr.success('Cuộc gọi chưa trả lời', '', {
                timeOut: 3000,
                positionClass: 'toast-bottom-right'
            });
            return;
        }
        let data = { action: 'transfer', callId: this.currentCall.callId, to: agentId };
        this.socketService.interact(data);
    }
    toOutPhone() {
        if (!this.currentCall.answered) {
            this.toastr.error('Cuộc gọi chưa trả lời', '', {
                timeOut: 3000,
                positionClass: 'toast-bottom-right'
            });
            return;
        }
        let phonenumber = this.modelPhoneOut.phone_out;
        if (phonenumber.length <= 9) {
            this.toastr.error('Số điện thoại không hợp lệ', '', {
                timeOut: 3000,
                positionClass: 'toast-bottom-right'
            });
            return;
        }
        this.lgModalOutPhone.hide();
        this.modelPhoneOut.phone_out = ''
        let data = { action: 'invitephone', callId: this.currentCall.callId, to: phonenumber };
        this.socketService.interact(data);
    }
    validatePhoneNumber(input_str) {
        var re = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;

        return re.test(input_str);
    }
    getStaffs(request: any = {}, sort: any = {}) {
        this.list = [];
        // this.socketService.getAgentAvailable({
        //     callId: this.ticket.call_id
        // })
        request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
        request.limit = this.page_size;
        if (Object.keys(sort).length == 2) {
            request['sort_by'] = sort.field + ':' + sort.typeSort
        }
        this.userService.list(request).subscribe(res => {
            if (res.status == 200 && res.error == false) {
                this.list = res.data.list;
                this.totalItem = res.data.total;
                var pageString = (this.totalItem / this.page_size).toString();
                var pageSplit = pageString.split('.');
                var last: any;
                var totalpage = parseInt(pageSplit[0]);
                if (pageSplit.length > 1) {
                    last = pageSplit[1];
                    if (parseInt(last) > 0) {
                        totalpage++
                    }
                }
                this.totalPage = totalpage;
            } else {
                this.list = [];
            }
        });
    }


    filterAgent() {
        let options = [];
        console.log(this.modelFilter.filter_agent_name ,this.modelFilter.group_id);
        if (this.modelFilter.filter_agent_name) {

            this.modelFilter.filter_agent_name.replace(/\s+/g, ' ').trim().split(" ").forEach(element => {
                options.push({
                    key: 'name',
                    condition : 'like',
                    value : element.toLowerCase()
                })
            });

        // this.currentPage = 1
        //     options.push({
        //         key: 'name',
        // condition : 'like',
        // value : this.modelFilter.filter_agent_name.trim().toLowerCase()
        //     })
        }
        if (this.modelFilter.group_id && this.modelFilter.group_id !== "all" ) {
        this.currentPage = 1
            options.push({
                key: 'group_id',
                condition: '=',
                value: this.modelFilter.group_id
            })
        }
        this.getStaffs({ filters: JSON.stringify(options) });
    }
    filterAgentpage() {
        let options = [];
        console.log(this.modelFilter.filter_agent_name ,this.modelFilter.group_id);
        if (this.modelFilter.filter_agent_name) {

            options.push({
                key: 'name',
        condition : 'like',
        value : this.modelFilter.filter_agent_name.trim().toLowerCase()
            })
        }
        if (this.modelFilter.group_id && this.modelFilter.group_id !== "all" ) {
            options.push({
                key: 'group_id',
                condition: '=',
                value: this.modelFilter.group_id
            })
        }
        this.getStaffs({ filters: JSON.stringify(options) });
    }
    changedFilterGroup(e: any): void {
        if (!this.is_load_data) {
            if (e.value) {
                this.modelFilter.group_id = e.value;
                // this.filterAgentpage()
            }
        }
    }
    getGroup() {
        this.groupService.allGroup().subscribe(res => {
            let groupList_tmp = [];
            groupList_tmp.push({
                id: 'all',
                text: '--Chọn--'
            });
            res.data.forEach((c: any) => {
                groupList_tmp.push({
                    text: c.name,
                    id: c.id,
                });
            });
            this.allFillterGroup = groupList_tmp;
        });
    }
    _keyPress(event: any) {
        if (event.charCode !== 0) {
            const pattern = /[0-9]/;
            const inputChar = String.fromCharCode(event.charCode);
            if (!pattern.test(inputChar)) {
                // invalid character, prevent input
                event.preventDefault();
            }
        }
    }
    goPage2(toPage: any) {
        toPage = parseInt(toPage);
        if (toPage && toPage > 0) {
            this.setPage(toPage);
        }
    }
    setPage(page: number) {
        if (page <= this.totalPage) {
            if (page < 1) {
                page = 1;
            }
            if (page != this.currentPage) {
                this.currentPage = page;
                this.filterAgentpage()
                // this.getStaffs()
            }
        }
        else {

            page = this.totalPage;
            $('#inputPage').val(page);
            this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            if (page <= this.totalPage) {
                if (page < 1) {
                    page = 1;
                }
                if (page != this.currentPage) {
                    this.currentPage = page;
                    this.getStaffs();
                }
            }
        }
    }
    isNotBroadcast(call) {
        if (call.callId.endsWith("CAST") || call.callId.endsWith("IVR")) {
            return false;
        }
        return true;
    }
}




// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/monitor/monitor.component.ts